import React, { useState } from "react";

import useCollapse from 'react-collapsed';
import LottoResultItems from "components/lotto/results/LottoResultItems";
import LottoKeywordHistory from "components/lotto/results/LottoKeywordHistory";
import LottoTopList from "components/lotto/results/LottoTopList";
import LottoDreamList from "components/lotto/results/LottoDreamList";
import DirectAdsComponent from "../../../components/lotto/default/DirectAdsComponent";
import CollapsibleHeader from "./CollapsibleHeader";

const INTRO_TEXT = {
  1: 'เลขไหนเด็ดของจริง ถูกบ่อย ถูกถี่กว่าเลขอื่น เช็คเลย',
  2: 'เลขเด็ดของคุณ เด็ดจริงไหม ถูกบ่อยแค่ไหน ไปดูกันเลย',
  3: 'เลขไหนเด็ดของจริง ถูกบ่อย ถูกถี่กว่าเลขอื่น เช็คเลย',
  9: 'เลขเด็ด เลขนำโชค เลขหลัก เลขรอง จากฝันนั้นคืออะไร ไปดูกันเลย',
};

export function ResultCollapsible({ id, topic, table, slug, isShowAtRender }) {
  const [isExpanded, setExpanded] = useState(isShowAtRender);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  function handleOnClick() {
    setExpanded(!isExpanded);
  }

  const shouldShow =
    (id === '1' && table?.data?.length > 0 && slug.length > 1) ||
    (id === '2' && table?.length > 0 && slug.length > 1) ||
    (id === '3' &&
      (table?.down2DigitsTopList?.length > 0 ||
        table?.up2DigitsTopList?.length > 0 ||
        table?.up3DigitsTopList?.length > 0)) ||
    (id === '9' && table?.length > 0);

  if (!shouldShow) return null;

  return (
    <section className="collapsible" aria-label={topic}>
      <div
        className={isExpanded ? 'header-expand' : 'header-collapse'}
        {...getToggleProps({ onClick: handleOnClick })}
      >
        <CollapsibleHeader topic={topic} isExpanded={isExpanded} />
      </div>
      <div {...getCollapseProps()}>
        <div className="collapsible-panel">
          {INTRO_TEXT[id] && <p className="collapsible-intro">{INTRO_TEXT[id]}</p>}
          <div className="collapsible-scroll">
            {id === '1' && <LottoResultItems results={table} />}
            {id === '2' && <LottoKeywordHistory results={table} slug={slug} />}
            {id === '3' && <LottoTopList results={table} slug={slug} />}
            {id === '9' && <LottoDreamList results={table} slug={slug} />}
          </div>
          <DirectAdsComponent adsType="lazada_bonus_deeplink" />
        </div>
      </div>
    </section>
  );
}
